import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { defaultWalletCurrency, currencyFormat } from '@investown/fe/common-utils';
import { QueryKeys, refetchIntervals, getWallet } from '@investown/fe/api-sdk';

import SkeletonRow from 'components/SkeletonRow';
import { PATH_WALLET } from 'routes/routesPaths';
import SpacerHorizontalDeprecated from 'components/SpacerHorizontalDeprecated';
import WalletIcon from 'components/Icons/WalletIcon';
import WalletOutlineIcon from 'components/Icons/WalletOutlineIcon';

export const WalletBalance: React.FC = () => {
  const intl: IntlShape = useIntl();
  const wallet = useQuery(QueryKeys.Wallet, getWallet, {
    refetchInterval: refetchIntervals.fiveMinutes,
  });
  // TODO: get currency from backend when real wallet is implementeds
  const { pathname } = useLocation();

  return (
    <StyledContainer to={PATH_WALLET} activeClassName="active">
      {pathname !== PATH_WALLET ? <WalletOutlineIcon /> : <WalletIcon />}
      <SpacerHorizontalDeprecated width="large" />
      {wallet.isLoading && <SkeletonRow width={70} />}

      {wallet.isSuccess && (
        <span>
          {currencyFormat({
            input: wallet.data.Wallet.availableBalance,
            currency: defaultWalletCurrency,
            locale: intl.locale,
          })}
        </span>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    span,
    svg {
      color: ${(props) => props.theme.color.primary};
      fill: ${(props) => props.theme.color.primary};
    }
  }

  span {
    color: ${(props) => props.theme.color.textColor};
  }

  &.active {
    span {
      color: ${(props) => props.theme.color.primary};
    }

    svg {
      fill: ${(props) => props.theme.color.primary};
    }
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.extraLarge}) {
    width: 100%;

    span {
      margin-left: ${(props) => props.theme.margins.medium};
    }

    div {
      display: none;
    }
  }
`;
